import { format } from 'date-fns';

export type SendStartInventoryEmailFormValues = {
  deadline: Date | null;
};

export const emptySendStartInventoryEmailFormValues: SendStartInventoryEmailFormValues = {
  deadline: null,
};

export interface SendStartInventoryEmailDto {
  deadline?: string;
}

// The deadline is a calendar day. Sending the local day, not toISOString(), keeps a Warsaw
// midnight from turning into the previous day in UTC on the server.
export const mapFormValuesToDto: (
  values: SendStartInventoryEmailFormValues,
) => SendStartInventoryEmailDto = (values) => ({
  deadline: values.deadline ? format(values.deadline, 'yyyy-MM-dd') : undefined,
});

export class InventoryStartHttpError extends Error {
  constructor(public status: number) {
    super(`Inventory start returned HTTP ${status}`);
  }
}

export interface StartInventoryResult {
  inventoryStarted: true;
  notifications: {
    recipientCount: number;
    acceptedCount: number;
    unconfirmedCount: number;
  };
}

export async function sendStartInventoryEmail(
  values: SendStartInventoryEmailFormValues,
): Promise<StartInventoryResult> {
  const dto = mapFormValuesToDto(values);
  const token = localStorage.getItem('atlasToken');
  const response = await fetch('/api/start-inventory', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
    body: JSON.stringify(dto),
  });
  if (!response.ok) {
    throw new InventoryStartHttpError(response.status);
  }
  const result = await response.json();
  const counts = result?.notifications;
  if (
    result?.inventoryStarted !== true ||
    !counts ||
    ![counts.recipientCount, counts.acceptedCount, counts.unconfirmedCount].every(
      (value) => Number.isInteger(value) && value >= 0,
    ) ||
    counts.acceptedCount + counts.unconfirmedCount !== counts.recipientCount
  ) {
    throw new Error('Inventory start returned an unknown outcome');
  }
  return result;
}
